const terms = [
  {
    title: "Terms",
    accordion: [
      {
        title: "Empty",
        elements: [
          {
            type: "title",
            text: "Emtpy Title ELement:",
          },
          {
            type: "p",
            text: "Empty Paragraph Element",
          },
        ],
      },
    ],
  },
];

export default terms;
